import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import ThongTinCongTy from './ThongTinCongTy';


const useStyles = makeStyles((theme) => ({
    boxTitle: {
        textAlign: 'center',
    },
    title: {
        marginBottom: theme.spacing(3),
        fontWeight: 'bold',
        fontSize: '1.5rem',
        color: '#000',
    },
    boldText: {
        fontWeight: 'bold',
    },
    link: {
        textDecoration: 'none !important',
        color: 'inherit !important', // Kế thừa màu từ button
        '&:hover': {
            textDecoration: 'none !important',
            color: 'inherit !important',
        },
        '&:focus': {
            outline: 'none !important',
        },
    },
    // THÊM CLASS MỚI CHO HÌNH ẢNH RESPONSIVE Ở ĐÂY
    responsiveImage: {
        maxWidth: '100%', // Đảm bảo hình ảnh không vượt quá chiều rộng của phần tử cha
        height: 'auto',   // Tự động điều chỉnh chiều cao để duy trì tỷ lệ khung hình
        display: 'block', // Đảm bảo hình ảnh là block-level để áp dụng margin tự động
        margin: theme.spacing(2, 'auto'), // Căn giữa hình ảnh và thêm khoảng cách trên/dưới
    },
}));

const GioiThieu = () => {
    const classes = useStyles();


    return (
        <Box className={classes.root}>
            <Box className={classes.boxTitle}>
                <Typography variant="h5" className={classes.title}>
                    Giới thiệu Thái Nguyên Ford
                </Typography>
            </Box>
            <Box>
                <Typography component="span" className={classes.boldText}>Chào mừng các bạn đã đến với Thái Nguyên Ford – Đại lý chính thức của Ford Việt Nam!</Typography>
                <br />
                <br />
                <Typography component="span" className={classes.boldText}>Thái Nguyên Ford tự hào là một trong những đại lý mới nhất của hãng mới vào hoạt động từ tháng 01 năm 2018 nhưng đã chiếm được sự tin tưởng và ủng hộ của các khách hàng trên địa bàn Tỉnh Thái Nguyên, Bắc Kạn, Cao Bằng…</Typography>
                <Typography variant="body1" >
                    Tiêu chí hoạt động của Thái Nguyên Ford chính là thấu hiểu và đáp ứng được đầy đủ những nhu cầu của khách hàng trong khu vực và ngày càng nâng cao mức độ hài lòng của khách hàng qua hệ thống cung cấp đồng bộ 3 cấp: Bán xe chất lượng cao – cung cấp phụ tùng chính hãng – dịch vụ bảo hành bảo dưỡng hoàn hảo.
                </Typography>
                <br />
                {/* ÁP DỤNG CLASS RESPONSIVEIMAGE VÀO THẺ IMG */}
                <img src='http://fordthainguyen.com.vn/uploads/about/thainguyenford.jpg' className={classes.responsiveImage} alt="Thái Nguyên Ford" />
                <br />
                <Typography variant="body1" >
                    Hiện nay, Thái Nguyên Ford đang cung cấp đầy đủ các mẫu xe Ford hiện đang có mặt trên thị trường Việt Nam như: Ford Ranger, Ford Everest mới, Ford Ecosport mới, Ford Focus mới, Ford Fiesta, xe thương mại 16 chỗ Ford Transit và dòng xe sang trọng Ford Explorer 2018. Đội ngũ tư vấn bán hàng chuyên nghiệp của Thái Nguyên Ford sẽ giúp khách hàng đưa ra những quyết định đúng đắn trong việc lựa chọn cho mình và gia đình chiếc xe vừa ý nhất phù hợp với nhu cầu sinh hoạt cũng như công việc hàng ngày bằng việc tư vấn cho khách hàng những tính năng, công dụng và chi tiết về đặc tính kỹ thuật của từng sản phẩm.
                </Typography>
                <br />
                {/* ÁP DỤNG CLASS RESPONSIVEIMAGE VÀO THẺ IMG */}
                <img src='http://fordthainguyen.com.vn/uploads/about/khai-truong-dai-ly-thai-nguyen-ford-1.jpg' className={classes.responsiveImage} alt="Khai trương đại lý" />
                <br />
                <Typography variant="body1" >
                    Đến với Trung tâm phụ tùng của Thái Nguyên Ford, chúng tôi đảm bảo luôn cung cấp những phụ tùng, phụ kiện chính hãng đúng như giá mà Ford Việt Nam quy định một cách nhanh chóng và thuận tiện cho quý khách hàng.</Typography>
                <br />
                <br />
                <Typography variant="body1" >
                    Trung tâm bảo hành – bảo dưỡng và sửa chữa của Thái Nguyên Ford với diện tích hơn 5.000m2 được chia thành nhiều khoang sửa chữa với trang thiết bị hiện đại đạt tiêu chuẩn khắt khe của Ford toàn cầu với 2 khoang sửa chữa nhanh, 10 khoang sửa chữa chung, 01 khoang kiểm tra an toàn phanh xe và chiếu sáng, 01 cầu nâng chỉnh lái hiện đại bậc nhất nhập khẩu từ Ý, xưởng đồng sơn được trang bị đầy đủ thiết bị phục vụ theo quy trình sơn nhanh 4 giờ cao cấp và hiện đại bậc nhất của Ford toàn cầu. Đặc biệt, Thái Nguyên Ford hiện là Đại lý duy nhất tại Việt Nam được trang bị bộ kéo nắn di động gồm thước đo điện tử 3D nhập khẩu từ Thụy Điển. Chúng tôi luôn sẵn sàng tiếp đón số lượng xe lớn đến bảo dưỡng sửa chữa cũng như phục hồi những xe tai nạn nặng. Với đội ngũ Kỹ thuật viên lên tới hơn 40 người, được đào tạo bài bản chính quy và có kinh nghiệm sẽ giúp khách hàng yên tâm khi mang xe tới Xưởng và Thái Nguyên Ford sẵn sàng cung cấp cho khách hàng nhưng dịch vụ sửa chữa hoàn hảo nhất.
                </Typography>
                <br />
                {/* ÁP DỤNG CLASS RESPONSIVEIMAGE VÀO THẺ IMG */}
                <img src='http://fordthainguyen.com.vn/uploads/about/khai-truong-dai-ly-thai-nguyen-ford-5.jpg' className={classes.responsiveImage} alt="Sửa chữa Ford" />
                <br />
                <Typography variant="body1" >
                    Để nâng cao độ hài lòng của khách hàng, đường dây nóng của Thái Nguyên Ford hoạt động 24/24 giờ sẽ hỗ trợ đắc lực khi chiếc xe của quý khách gặp bất cứ vấn đề trục trặc về kỹ thuật, sẵn sàng lắng nghe và giải đáp mọi thắc mắc của quý khách hàng. Bên cạnh đó, chúng tôi liên tục tổ chức những chương trình khuyến mãi, bốc thăm trúng thưởng và các chương trình trải nghiệm thực tế như lái thử xe… để đem lại những lợi ích cao nhất cho khách hàng trung thành và khách hàng tiềm năng.
                </Typography>
                <br />
                {/* ÁP DỤNG CLASS RESPONSIVEIMAGE VÀO THẺ IMG */}
                <img src='http://fordthainguyen.com.vn/uploads/about/tnf2.jpg' className={classes.responsiveImage} alt="Trải nghiệm Ford" />
                <br />
                <Typography variant="body1" >
                    Với đội ngũ bán hàng trẻ, nhiệt huyết và chuyên nghiệp trong tư vấn, chúng tôi tin tưởng sẽ giúp quý khách lựa chọn được những chiếc xe hữu ích, có giá trị sử dụng cao với những tính năng ưu việt, thông minh, an toàn và tiết kiệm. Cùng với đó là là bộ phận dịch vụ với đội ngũ kỹ thuật viên có tay nghề cao, phụ tùng chính hãng chắc chắn sẽ giúp quý khách hàng có được sự an tâm và an toàn trên mọi cung đường của tổ quốc Và để hoàn thiện và nâng cao khả năng đáp ứng cũng như mang lại sự hài lòng cao nhất, chúng tôi luôn luôn lắng nghe và tiếp nhận tất cả mọi thông tin và những phản hồi từ phía khách hàng, cùng với phòng chăm sóc khách hàng cải thiện và mang lại hiệu quả cao nhất trong việc chăm sóc khách hàng.
                </Typography>
                <br />
                <br />
                <Typography component="span" className={classes.boldText}>Hãy đến để trải nghiệm những dịch vụ và nhận những ưu đãi tuyệt vời nhất từ Thái Nguyên Ford dành cho quý khách hàng ngay từ ngày hôm nay.</Typography>
                <br />
                <br />
                <ThongTinCongTy />
            </Box>
        </Box>
    );
};

export default GioiThieu;